export default function (id) {
  return `[beagl id="${id}"]`
}
